import evaluateRestQuery, {
  type EvaluateRestQueryResponse,
} from "./evaluateRestQuery";
export { EvaluateRestQueryResponse };
export default evaluateRestQuery;
